import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rp-home-seo-optimization-schema',
  standalone: true,
  templateUrl: './seo-optimization-schema.component.html',
  styleUrl: './../schema.base.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class SeoOptimizationSchemaComponent {}
